import moment from 'moment-timezone'

export const setTimezone = moment.tz.setDefault

export default moment
